module.exports = __webpack_public_path__ + "img/price.7f8d7353.png";